import { render } from "./PermisosHijas.vue?vue&type=template&id=6aa1786c&scoped=true"
import script from "./PermisosHijas.vue?vue&type=script&lang=js"
export * from "./PermisosHijas.vue?vue&type=script&lang=js"

import "./PermisosHijas.vue?vue&type=style&index=0&id=6aa1786c&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa1786c"]])

export default __exports__